//Permanent
const brand = "El Comercio";
const twitterAccount = "elcomercio_peru";    
const urlBrand = "https://elcomercio.pe/";
const urlPortadaEspeciales = "https://especiales.elcomercio.pe/?q=especiales/especiales-el-comercio/index.html";
const domainMarca = "https://especiales.elcomercio.pe/?q=especiales/";
const domainAssets = 'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_prod/especiales/';
const urlCommonAssets = `${domainAssets}elementos-comunes-2`;

//Variable
const socialShareText = `El expediente Juan Reynoso: Nuevo DT selección peruana | ${brand}`;
const slugEspecial = "el-expediente-juan-reynoso-nuevo-dt-seleccion-peruana-multimedia-nndd";
const urlEspecial = `${domainMarca}${slugEspecial}/index.html`;
const urlAssets = `${domainAssets}${slugEspecial}`;
const urlJson = `${domainAssets}${slugEspecial}/json/photogallery.json?dhf`;
const queryStringText = 'dato';

export { 
    brand,
    queryStringText,
    twitterAccount, 
    urlBrand, 
    urlPortadaEspeciales, 
    domainMarca, 
    domainAssets, 
    urlCommonAssets, 
    socialShareText, 
    slugEspecial, 
    urlEspecial, 
    urlAssets, 
    urlJson 
}